var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseApplyManageService } from "~/services/business-service/case-apply-manage.service";
import { Emit, Prop } from "vue-property-decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import DataBox from "~/components/common/data-box.vue";
var VisitManageVisiting = /** @class */ (function (_super) {
    __extends(VisitManageVisiting, _super);
    function VisitManageVisiting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visitDataSet = [];
        _this.searchModel = {
            assistStatus: "",
        };
        _this.selectionList = [];
        _this.loading = {
            state: false,
        };
        return _this;
    }
    VisitManageVisiting.prototype.refreshList = function () { };
    VisitManageVisiting.prototype.close = function () { };
    VisitManageVisiting.prototype.refreshData = function () {
        var _this = this;
        var searchModel = Object.assign(this.searchModel, this.visitModel);
        searchModel.assistStatus = "ASSIST_COLLECTING"; //外访中
        // searchModel.applyDateStart = this.visitModel.applyDate[0]
        // searchModel.applyDateEnd = this.visitModel.applyDate[1]
        // searchModel.applyDate =''
        this.caseApplyManageService.searchAssistCase(searchModel, this.pageService, this.sortService, this.loading).subscribe(function (data) {
            _this.visitDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], VisitManageVisiting.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], VisitManageVisiting.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], VisitManageVisiting.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit("refreshList")
    ], VisitManageVisiting.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], VisitManageVisiting.prototype, "close", null);
    __decorate([
        Prop()
    ], VisitManageVisiting.prototype, "visitModel", void 0);
    VisitManageVisiting = __decorate([
        Component({
            components: {
                DataBox: DataBox,
            },
        })
    ], VisitManageVisiting);
    return VisitManageVisiting;
}(Vue));
export default VisitManageVisiting;
